var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mb-3",attrs:{"color":"blue","outlined":""},on:{"click":function($event){return _vm.$emit('lockUnlockAllFields')}}},[_vm._v(" "+_vm._s(_vm.textBtn)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }